import { Observable, throwError } from 'rxjs';
import { Inject, Injectable, Injector, SkipSelf } from '@angular/core';
import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { ContinueJourneyResponse, DiscoveryChatQuestion } from './model/discovery-chat.interface';
import { APIS } from '../apis';
// import { tEnvironment } from '../moov-common/tokens/environment.token';
// import { IEnvironment } from 'src/environments/environment.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractDiscoveryProcessService {

  abstract startUserJourney(): Observable<string>;

  abstract continueUserJourney(): Observable<ContinueJourneyResponse>;

  abstract getNextBatch(userId: string): Observable<DiscoveryChatQuestion[]>;

  abstract journeyGetQuestionsInBatch(): Observable<DiscoveryChatQuestion[]>;

  abstract journeySetQuestionResponse(questionId: string, responseIds: string[]): Observable<string>;

  abstract rediscoverGetQuestionsForMotivation(motivationInDispute: string): Observable<DiscoveryChatQuestion[]>;
  
  abstract rediscoverGetTailQuestion(motivationInDispute: string): Observable<DiscoveryChatQuestion[]>;
  
  abstract rediscoverGetMotivationGapQuestion(newMotivationId: string): Observable<DiscoveryChatQuestion[]>;
  
  abstract rediscoverUpdateUserMotviation(motivationInDispute: string, newMotivationId: string, motivationGapScore: number): Observable<string>;
}
